import { Button, Spin, Tabs } from 'antd'
import TabPane from 'antd/es/tabs/TabPane';
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchSOWAgeingReport, getSOWAgeingDownloadFile } from '../../store/reducers/reportsSlice';
import { rejectedApiMessage } from '../../utilities/CommonHelper';
import SowAgeingWithoutWO from '../SOWAgeingWithoutWO/sowAgeingWithoutWO';
import SowAgeingWithoutOpp from '../SOWAgeingWithoutOpp/sowAgeingWithoutOpp';
import { DownloadOutlined } from '@ant-design/icons';

import "./sowAgeingReportContainer.css";


interface DataType {
    key: React.Key;
    sowId: string;
    sowName: string;
    clientEntity: string;
    child: boolean;
    sowStartDate: string;
    sowEndDate: string;
    currency: string;
    contractValue: string;
    contractValueUsd: string;
    sowWithoutOpportunitySinceDate: string;
    sowWithoutOpportunitySinceNumberOfDays: string;
    sowWithoutWorkOrderSinceDate: string;
    sowWithoutWorkOrderSinceNumberOfDays: string;
}

const SowAgeingReportContainer = () => {

    const dispatch = useDispatch();
    const reportsData = useSelector((state: any) => state.reports);
    const [sowWithoutOpportunityList, setSowWithoutOpportunityList] = React.useState<DataType[]>([]);
    const [sowWithoutWorkOrderList, setSowWithoutWorkOrderList] = React.useState<DataType[]>([]);

    useEffect(() => {
        dispatch(fetchSOWAgeingReport()).then((res: any) => {
            if (res.type === 'reports/fetchSOWAgeingReport/fulfilled') {
              setSowWithoutOpportunityList(res.payload?.sowDetailsWithoutOpportunity.map((it:DataType)=>{return {...it, 'child':it.child?"Yes":"No"}}) || [] );
              setSowWithoutWorkOrderList(res.payload?.sowDetailsWithoutWorkOrder.map((it:DataType)=>{return {...it, 'child':it.child?"Yes":"No"}}) || [] );
              
            }else{
              rejectedApiMessage(res.payload);
            } 
          });
    }, [])

    const handleReportDownload = () => {
        {
            dispatch(getSOWAgeingDownloadFile({payload:{}})).then(
              (response: any) => {
                if (response.type !== 'reports/getSOWAgeingDownloadFile/fulfilled') {
                  rejectedApiMessage(response.payload);
                }
                else{
                  
                  const fileName = response.payload?.headers?.get("content-disposition")?.split("filename=")[1];
                  const blob = response.payload.data;
                  const url = window.URL.createObjectURL(blob);
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', fileName); //or any other extension
                  document.body.appendChild(link);
                  link.click();
                  link.remove();
                }
              }
            );
          }
    }


  return (
    <Spin spinning={reportsData?.loading } tip="Loading..." >
    <div className='row'>
        <h2 className='col-lg-6 col-sm-12 page-heading'>
            SOW Ageing Report
        </h2>
        <div className='col-lg-6 col-sm-12' style={{display:'flex',justifyContent:'flex-end', padding:'20px'}}>
        <Button type="primary" style={{borderRadius:'0', backgroundColor:'#034ea2', font:'normal normal 600 12px / 16px Nunito Sans'}}
         icon={<DownloadOutlined />} 
         size={'large'}
         onClick={()=>handleReportDownload()}>
            Download
          </Button>
        </div>
        

    </div>
    <Tabs defaultActiveKey="1" type="card">
        <TabPane tab="SOW Without Opportunity" key="1">
           <SowAgeingWithoutOpp sowWithoutOpportunityList={sowWithoutOpportunityList} />       
        </TabPane>
        <TabPane tab="SOW Without Work Order" key="2">
            <SowAgeingWithoutWO sowWithoutWorkOrderList={sowWithoutWorkOrderList} />
        </TabPane>
    </Tabs>
    </Spin>
  )
}

export default SowAgeingReportContainer